import { Col, Form, Row } from "react-bootstrap";
import styled from "styled-components";

export const TabPanelRow = styled(Row)`
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.bg3};  // Cor de fundo para linhas pares
  }
`;

export const CheckBox = styled(Form.Check)`
    color: inherit;
    font-size: 16px;
    text-align: center;
    align-items: center;

    .form-check-input{
        border-color: rgb(161 161 161)
    }
`;

export const ColunmCheck = styled(Col)`
    border: solid 1px rgb(117 117 117);
    display: "flex";
    alignItems: "center";
    alignContent: "center";
    flexWrap: "wrap";
    flexDirection: "row";
    justifyContent: "center"
`; 